
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.6.5h10.8A3.6 3.6 0 0118 4.1v10.8a3.6 3.6 0 01-3.6 3.6H3.6A3.6 3.6 0 010 14.9V4.1A3.6 3.6 0 013.6.5zm6.075 9.675H12.6a.675.675 0 100-1.35H9.675V5.9a.675.675 0 00-1.35 0v2.925H5.4a.675.675 0 000 1.35h2.925V13.1a.675.675 0 101.35 0v-2.925z","fill":"#7B01B5"}})])
          )
        }
      }
    